// extracted by mini-css-extract-plugin
export var carrierIcon = "_wr-0";
export var carrierLogo = "_wr-1";
export var detailsSection = "_wr-2";